module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABMUlEQVQokZ2TTStFYRDHf04npSiJ1ZUF3buST6BOsnK3voKVna9he+7SJ7AWJSuWNmIhyULqUjZeShTnrzl3njyd7hOZmvOcmf7zPoOkmHNJpaQHSV8a0KfLps9j/Ih9nApgHxgDzoED4BpoA2vAEvAGdIHj2sS9FB6pL6nTyCaw6e8dV4TIOfAEvAItoCJNo8AtMAFM4rVUkhYSEZvcdnyJN+PsD0Ynkj783/CPGTADHHqiW8B0I2nDnALLwK7rjoApfByb7tGa8Syp5XIm6cIxO1EWhlfmDZpzj+vAOHAFdIBLYBEogY0om/nabkjNXV+MyiNuD6m/rjnV7VVJ741UA4du9+I5vwCzv8zZsHfxnI1X/rthqd3eA258t22fk7sd2K6m17gqe002/c9VSXwDoRfuYSxzBAUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_cy.png
// module id = 6Fmk
// module chunks = 181